module.exports = __webpack_public_path__ + "img/slide17.c99cdd25.jpg";